<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text>
        <FacilityDocuForm
            ref="facilityDocuForm"
            :isGlobal="isGlobal"
            @dialogClosed="closeDialog"
            @updateDocuData="(tableOptions, tableSearch) => $emit('updateDocuData', tableOptions, tableSearch)"
            />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import FacilityDocuForm from '@/modules/book/views/facility/facility/formDialogs/form/FacilityDocuForm.vue';

export default {
  name: 'FacilityDocuDialogForm',
  components: {
    FacilityDocuForm
  },
  data() {
    return {
      dialog: false
    }
  },
  props: {
    isGlobal: Boolean
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.facilityDocuForm.clearForm();
      this.$emit('updateDocuData');
    },
    addDocu(options, search) {
      this.$refs.facilityDocuForm.addDocu(options, search);
      this.dialog = true;
    },
    editGlobalDocumentation(facilityBuildList, item, options, search) {
      this.$refs.facilityDocuForm.editGlobalDocumentation(facilityBuildList, item, options, search);
      this.dialog = true;
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.$refs.facilityDocuForm.loadEnums();
      }
    }
  }
}
</script>